"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InitOllamaModelEdge = exports.InitEnableEdgeAI = exports.InitEdgeServerHeader = exports.InitEdgeServer = exports.InitCRUDModel = void 0;
var _globalStates = require("../../globalstates/globalStates");
var _uuid = require("uuid");
var InitEnableEdgeAI = exports.InitEnableEdgeAI = function InitEnableEdgeAI() {
  return {
    enabled: false
  };
};
var InitEdgeServerHeader = exports.InitEdgeServerHeader = function InitEdgeServerHeader() {
  return {
    id: {
      value: (0, _uuid.v4)()
    },
    name: "",
    edgeUrl: "",
    edgeUsername: "",
    edgePassword: "",
    sdkAccessUrl: "",
    sdkUsername: "",
    sdkPassword: "",
    enabled: false
  };
};
var InitEdgeServer = exports.InitEdgeServer = function InitEdgeServer() {
  return {
    id: {
      value: (0, _uuid.v4)()
    },
    name: "",
    edgeUrl: "",
    edgeUsername: "",
    edgePassword: "",
    sdkAccessUrl: (0, _globalStates.getGlobalStates)().host || "",
    sdkUsername: "",
    sdkPassword: "",
    enabled: true,
    createdTime: "",
    updatedTime: ""
  };
};
var InitOllamaModelEdge = exports.InitOllamaModelEdge = function InitOllamaModelEdge() {
  return {
    id: {
      value: ""
    },
    models: []
  };
};
var InitCRUDModel = exports.InitCRUDModel = function InitCRUDModel(value) {
  return {
    id: {
      value: value
    },
    model: ""
  };
};